import { fetchPayorsForStore } from "../services/store-info-service";

export const DEFAULT_PAYOR = ["default"];

export const getStoreIdFromQueryString = (
  query: string
): string | undefined => {
  const storeIdRegExp = /s(?<storeId>\d+)/iu;
  return storeIdRegExp.exec(query)?.groups?.storeId;
};

export function getPayorsFromStoreId(storeId: string): string[] {
  if (storeId === "") {
    return DEFAULT_PAYOR;
  }
  try {
    const result = fetchPayorsForStore(storeId);
    if (result.length > 0) {
      return result;
    }
  } catch {
    return DEFAULT_PAYOR;
  }
  return DEFAULT_PAYOR;
}
